// extracted by mini-css-extract-plugin
export default {"root":"mimic___styles_root__-Dp3F","sidebarContainer":"mimic___styles_sidebarContainer__J5qtJ","header":"mimic___styles_header__kDcTo","footer":"mimic___styles_footer__JAZDz"};